import React, { Component } from 'react'
import RadioBttn from '../../../../components/common/buttons/RadioBttn'
import { Auth } from '../../../../helpers'

class ScalingButtons extends Component {
  render () {
    const { myVote, handleVoting } = this.props

    return (
      <div className='vote-bttns-container'>
        <RadioBttn
          text='1'
          selected={myVote && myVote.vote === 1}
          onClick={() => handleVoting(1)}
          clickable={!Auth.isAdmin()}
        />
        <RadioBttn
          text='2'
          selected={myVote && myVote.vote === 2}
          onClick={() => handleVoting(2)}
          clickable={!Auth.isAdmin()}
        />
        <RadioBttn
          text='3'
          selected={myVote && myVote.vote === 3}
          onClick={() => handleVoting(3)}
          clickable={!Auth.isAdmin()}
        />
        <RadioBttn
          text='4'
          selected={myVote && myVote.vote === 4}
          onClick={() => handleVoting(4)}
          clickable={!Auth.isAdmin()}
        />
        <RadioBttn
          text='5'
          selected={myVote && myVote.vote === 5}
          onClick={() => handleVoting(5)}
          clickable={!Auth.isAdmin()}
        />
      </div>
    )
  }
}

export default ScalingButtons



// WEBPACK FOOTER //
// ./src/screens/dashboard/chat/buttons/ScalingButtons.js